import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { browserLang } from "@/lib/lang";
import { useSeoTags } from "@/lib/seo";
import MessageCard from "@/components/MessageCard";

const FILTERS = [
  { key: "loud", label: "Loud" },
  { key: "new", label: "New" },
  { key: "trending", label: "Trending" },
  { key: "far", label: "Far" },
];

const CATEGORIES = [
  { key: "all", label: "All" },
  { key: "peace", label: "Peace" },
  { key: "solidarity", label: "Solidarity" },
  { key: "gratitude", label: "Gratitude" },
  { key: "sport", label: "Sport" },
  { key: "person_support", label: "Person" },
  { key: "organisation_team", label: "Organisation" },
  { key: "environment", label: "Environment" },
  { key: "culture_music", label: "Culture" },
  { key: "event", label: "Event" },
  { key: "global_cause", label: "Global cause" },
];

export default function ExplorePage() {
  const [q, setQ] = useState("");
  const [filter, setFilter] = useState("loud");
  const [category, setCategory] = useState("all");
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const params = new URLSearchParams({ filter, limit: "24", lang: browserLang() });
    if (q) params.set("q", q);
    if (category !== "all") params.set("category", category);
    api.get(`/messages?${params.toString()}`)
      .then((r) => setItems(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [q, filter, category]);

  useSeoTags(
    {
      title: "Explore MESSAGES — VOIHU",
      description:
        "Browse public MESSAGES from humans around the world on VOIHU. Add your VOICE to the ones that move you and let them travel further.",
      canonical: "https://voihuworld.com/explore",
      ogType: "website",
    },
    [],
  );

  return (
    <div className="max-w-[1400px] mx-auto px-6 sm:px-10 pt-16 pb-24">
      <div className="oh-label">Explore</div>
      <h1 className="font-serif-editorial text-5xl sm:text-7xl leading-[0.95] mt-4">Find a message.</h1>

      <input
        placeholder="Search for a message, a person, a cause…"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        className="oh-input mt-10 text-2xl sm:text-3xl font-serif-editorial"
        data-testid="explore-search"
      />

      <div className="mt-8 flex flex-wrap gap-6 items-center border-b oh-hairline pb-6">
        <div className="flex gap-1">
          {FILTERS.map((f) => (
            <button key={f.key} onClick={() => setFilter(f.key)}
                    className={`px-4 py-2 text-xs uppercase tracking-wider transition-colors ${filter === f.key ? "bg-[color:var(--oh-ink)] text-[color:var(--oh-bg)]" : "hover:bg-[color:var(--oh-bg-2)]"}`}
                    data-testid={`filter-${f.key}`}>
              {f.label}
            </button>
          ))}
        </div>
        <div className="flex gap-1 flex-wrap">
          {CATEGORIES.map((c) => (
            <button key={c.key} onClick={() => setCategory(c.key)}
                    className={`px-3 py-2 text-xs uppercase tracking-wider transition-colors border oh-hairline ${category === c.key ? "bg-[color:var(--oh-ink)] text-[color:var(--oh-bg)] border-[color:var(--oh-ink)]" : "hover:bg-[color:var(--oh-bg-2)]"}`}
                    data-testid={`cat-${c.key}`}>
              {c.label}
            </button>
          ))}
        </div>
      </div>

      {loading ? (
        <div className="mt-16 oh-label">Listening…</div>
      ) : items.length === 0 ? (
        <div className="mt-16 font-serif-editorial text-3xl text-[color:var(--oh-ink-2)]">
          No message here yet. Start one.
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-10">
          {items.map((m, i) => (<MessageCard key={m.id} m={m} i={i} />))}
        </div>
      )}
    </div>
  );
}
